var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.88 13.44L9.14 11.7C8.99333 11.5533 8.81333 11.48 8.6 11.48C8.38667 11.48 8.2 11.56 8.04 11.72C7.89333 11.8667 7.82 12.0533 7.82 12.28C7.82 12.5067 7.89333 12.6933 8.04 12.84L10.32 15.12C10.4667 15.2667 10.6533 15.34 10.88 15.34C11.1067 15.34 11.2933 15.2667 11.44 15.12L15.98 10.58C16.1267 10.4333 16.2 10.2533 16.2 10.04C16.2 9.82667 16.12 9.64 15.96 9.48C15.8133 9.33333 15.6267 9.26 15.4 9.26C15.1733 9.26 14.9867 9.33333 14.84 9.48L10.88 13.44ZM12 20C10.8933 20 9.85333 19.7899 8.88 19.3696C7.90667 18.9499 7.06 18.38 6.34 17.66C5.62 16.94 5.05013 16.0933 4.6304 15.12C4.21013 14.1467 4 13.1067 4 12C4 10.8933 4.21013 9.85333 4.6304 8.88C5.05013 7.90667 5.62 7.06 6.34 6.34C7.06 5.62 7.90667 5.04987 8.88 4.6296C9.85333 4.20987 10.8933 4 12 4C13.1067 4 14.1467 4.20987 15.12 4.6296C16.0933 5.04987 16.94 5.62 17.66 6.34C18.38 7.06 18.9499 7.90667 19.3696 8.88C19.7899 9.85333 20 10.8933 20 12C20 13.1067 19.7899 14.1467 19.3696 15.12C18.9499 16.0933 18.38 16.94 17.66 17.66C16.94 18.38 16.0933 18.9499 15.12 19.3696C14.1467 19.7899 13.1067 20 12 20Z",
    fill: "#A3AFC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGray);
export default __webpack_public_path__ + "static/media/gray.08bcf29b94cb5f24e8707ed84a09a59d.svg";
export { ForwardRef as ReactComponent };